import { render, staticRenderFns } from "./UnlockModal.vue?vue&type=template&id=af272f24&scoped=true"
import script from "./UnlockModal.vue?vue&type=script&lang=js"
export * from "./UnlockModal.vue?vue&type=script&lang=js"
import style0 from "./UnlockModal.vue?vue&type=style&index=0&id=af272f24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af272f24",
  null
  
)

export default component.exports